export default {
   landing: {
      welcome: {
         title: 'CBAS – Cyanobacteria Bloom Alert',
         description: 'CBAS is an application used to monitor the cyanobacteria blooms of the Polish lakes. With the use of the satellite data, we conduct continuous observation of water reservoirs. Thanks to the mobile application, our users can receive warnings about the bloom of cyanobacteria.',
         explore: 'Explore'
      },
      newsletter: {
         emailActionDescription: 'Do you want to receive email notifications on cyanobacterial hazards?',
         emailPlaceholder: 'Enter your e-mail address',
         emailEmptyError: 'Please input your email address',
         emailInvalidError: 'Please input correct email address',
         subscribeButton: 'SUBMIT',
         privacy: {
            text: 'The information filled through the newsletter field will be used in accordance to our',
            link: 'privacy policy'
         }
      },
      aboutUs: {
         title: 'About',
         columnA: 'CBAS is a project carried out in a Polish-French consortium aimed at providing infrastructure for continuous monitoring of inland waters in Poland and Europe. The pilot project focuses on the area of Kashubia and the Vistula Lagoon. The blooms of cyanobacteria occur in water bodies around the world in both inland waters as well as seas and oceans. Cyanobacteria Blooms are conditioned physicochemical factors such as sunlight, temperature, pH, and also on the composition of water. The contamination from fields and urban areas flowing into the water is of great importance in the formation of the blooms.',
         columnB: 'So far, about 40 species of cyanobacteria have been identified that are potentially toxic. It is estimated that about 50% of all water blooms are associated with the production of toxins. Harmful algal blooms have significant impact on the economy of coastal and tourist areas, as well as on human and animal health. Contact with toxins produced by cyanobacteria may cause acute skin reactions and is potentially dangerous. Blooms occurring in areas of great importance in fisheries lead to significant economic losses as well as to losses related to the reduction of tourism.',
         features: [{
               title: '7000',
               content: 'There are so many lakes in Poland.'
            },
            {
               title: '197',
               content: 'So many bathing areas were monitored by the State Sanitary Inspection in 2015'
            },
            {
               title: '85%',
               content: 'Such part of all bathing areas monitored in 2015 met sanitary conditions.'
            },
            {
               title: '50%',
               content: 'Over 50% of water reservoirs in Poland are characterized as favorable to flowering.'
            },
            {
               title: '1 - 16',
               content: 'The time of water bloom in the reservoir varies from 1 to 16 weeks and depends on many factors.'
            },
         ]
      },
      howItWorks: {
         title: 'How does it work?',
         step: 'STEP',
         steps: [{
               title: 'Analysis of satellite data',
               content: 'We use satellite data from the European satellites Sentinel 2 and Sentinel 3 as well as satellite Landsat 8 belonging to NASA. We study the concentration of chlorophyll-a and phycocyanins in water reservoirs and on this basis we identify areas at risk of bloom.'
            },
            {
               title: 'Water sample analysis',
               content: 'The results of our algorithms are sent to specialists who then carry out microbiological tests of water in the indicated lakes. On this basis, we are able to evaluate the accuracy of the algorithms and confirm the threat.'
            },
            {
               title: 'Information about the threat',
               content: 'When the algorithms or microbiological test results indicate a threat, we inform users about it. The warnings are distributed through a dedicated mobile application and a mailing list.'
            }
         ]
      }
   },
   cookies: {
      alert: 'This page uses cookies and Google Analytics for statistical data collecting. If you wish to know more, please read our privacy policy.',
      accept: 'Accept',
      more: 'Privacy policy'
   },
   privacy: {
      title: 'Polityka prywatności serwisu WWW sinice.pl',
      items: [{
            title: 'INFORMACJE OGÓLNE',
            items: [{
                  title: 'Operatorem Serwisu sinice.pl jest N7 Mobile Sp. z o.o., z siedzibą przy ul. Bukowińskiej 12/1301, 02-703 Warszawa, NIP: 952-21-04-393, KRS: 0000378709'
               },
               {
                  title: 'Serwis realizuje funkcje pozyskiwania informacji o użytkownikach i ich zachowaniach w następujący sposób:',
                  items: [{
                        title: 'Poprzez dobrowolnie wprowadzone w formularzach informacje'
                     },
                     {
                        title: 'Poprzez zapisywanie w urządzeniach końcowych pliki cookie (tzw. „ciasteczka”).'
                     },
                     {
                        title: 'Poprzez zapisywanie technicznych logów na poziomie serwera www, obsługiwanego przez OVH (operator hostingu prowadzi swoją stronę pod adresem http://ovh.com. Operatorem jest OVH Sp. z o.o.).'
                     }
                  ]
               }, {
                  title: 'Niniejsza Polityka jest dokumentem informacyjnym i nie zastępuje polityki bezpieczeństwa, prowadzonej przez Operatora Serwisu zgodnie zgodnie z przepisami o ochronie danych osobowych.'
               },
               {
                  title: 'W zakresie danych, będących danymi osobowymi w świetnie przepisów o ochronie danych osobowych, administratorem danych jest Operator Serwisu.'
               }
            ]
         }, {
            title: 'INFORMACJE W FORMULARZACH.',
            items: [{
                  title: 'Serwis zbiera informacje podane dobrowolnie przez użytkownika.'
               },
               {
                  title: 'Serwis może zapisać ponadto informacje o parametrach połączenia (oznaczenie czasu, adres IP)'
               },
               {
                  title: 'Dane w formularzu nie są udostępniane podmiotom trzecim inaczej, niż za zgodą użytkownika.'
               },
               {
                  title: 'Dane podane w formularzu mogą stanowić zbiór danych osobowych, wówczas taki zbiór jest rejestrowany przez Operatora Serwisu w rejestrze prowadzonym przez Generalnego Inspektora Ochrony Danych Osobowych.'
               },
               {
                  title: 'Jeśli dane w formularzu umożliwiają identyfikację osoby fizycznej, to osoba taka ma prawdo do wglądu, modyfikacji i żądania zaprzestania przetwarzania swoich danych w dowolnym momencie. Możliwe jednak, że będzie to powodowało brak dostępu do niektórych funkcji serwisu.'
               },
               {
                  title: 'Dane podane w formularzu są przetwarzane w celu wynikającym z funkcji konkretnego formularza, np. w celu wysyłania ostrzeżeń o występowaniu zakwitów sinic na monitorowanych jeziorach. '
               }
            ]
         }, {
            title: 'INFORMACJA O PLIKACH COOKIES.',
            items: [{
                  title: 'Serwis korzysta z plików cookies.'
               },
               {
                  title: 'Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu. Pliki tego rodzaju zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.'
               },
               {
                  title: 'Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu lub podmioty z nim współpracujące.'
               },
               {
                  title: 'Dane podane w formularzu mogą stanowić zbiór danych osobowych, wówczas taki zbiór jest rejestrowany przez Operatora Serwisu w rejestrze prowadzonym przez Generalnego Inspektora Ochrony Danych Osobowych.'
               },
               {
                  title: 'Pliki cookies wykorzystywane są w następujących celach:',
                  items: [{
                        title: 'tworzenia statystyk, które pomagają zrozumieć, w jaki sposób Użytkownicy Serwisu korzystają ze stron internetowych, co umożliwia ulepszanie ich struktury i zawartości;'
                     },
                     {
                        title: 'utrzymanie sesji Użytkownika Serwisu (po zalogowaniu), dzięki której Użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;'
                     },
                     {
                        title: 'w celu zapamiętania składu koszyka użytkownika w sklepie internetowym,'
                     },
                     {
                        title: 'określania profilu użytkownika w celu wyświetlania mu dopasowanych materiałów w sieciach reklamowych, w szczególności sieci Google.'
                     }
                  ]
               },
               {
                  title: 'W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies) oraz „stałe” (persistent cookies). Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania (przeglądarki internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.'
               },
               {
                  title: 'Oprogramowanie do przeglądania stron internetowych (przeglądarka internetowa) zazwyczaj domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać zmiany ustawień w tym zakresie. Przeglądarka internetowa umożliwia usunięcie plików cookies. Możliwe jest także automatyczne blokowanie plików cookies Szczegółowe informacje na ten temat zawiera pomoc lub dokumentacja przeglądarki internetowej.'
               },
               {
                  title: 'Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu.'
               },
               {
                  title: 'Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu i wykorzystywane mogą być również przez współpracujących z operatorem Serwisu reklamodawców oraz partnerów, a także operatorów płatności.'
               },
               {
                  title: 'Zalecamy przeczytanie polityki ochrony prywatności tych firm, aby poznać zasady korzystania z plików cookie wykorzystywane w statystykach: Polityka ochrony prywatności Google Analytics'
               },
               {
                  title: 'Pliki cookie mogą być wykorzystane przez sieci reklamowe, w szczególności sieć Google, do wyświetlenia reklam dopasowanych do sposobu, w jaki użytkownik korzysta z Serwisu. W tym celu mogą zachować informację o ścieżce nawigacji użytkownika lub czasie pozostawania na danej stronie.'
               },
               {
                  title: 'W zakresie informacji o preferencjach użytkownika gromadzonych przez sieć reklamową Google użytkownik może przeglądać i edytować informacje wynikające z plików cookies przy pomocy narzędzia: https://www.google.com/ads/preferences/'
               }
            ]
         }, {
            title: 'LOGI SERWERA',
            items: [{
                  title: 'Informacje o niektórych zachowaniach użytkowników podlegają logowaniu w warstwie serwerowej. Dane te są wykorzystywane wyłącznie w celu administrowania serwisem oraz w celu zapewnienia jak najbardziej sprawnej obsługi świadczonych usług hostingowych.'
               },
               {
                  title: 'Przeglądane zasoby identyfikowane są poprzez adresy URL. Ponadto zapisowi mogą podlegać:',
                  items: [{
                        title: 'czas nadejścia zapytania,'
                     },
                     {
                        title: 'czas wysłania odpowiedzi,'
                     },
                     {
                        title: 'nazwę stacji klienta – identyfikacja realizowana przez protokół HTTP,'
                     },
                     {
                        title: 'informacje o błędach jakie nastąpiły przy realizacji transakcji HTTP,'
                     },
                     {
                        title: 'adres URL strony poprzednio odwiedzanej przez użytkownika (referer link) – w przypadku gdy przejście do Serwisu nastąpiło przez odnośnik,'
                     },
                     {
                        title: 'informacje o przeglądarce użytkownika,'
                     },
                     {
                        title: 'informacje o adresie IP.'
                     }
                  ]
               },
               {
                  title: 'Dane powyższe nie są kojarzone z konkretnymi osobami przeglądającymi strony.'
               },
               {
                  title: 'Dane powyższe są wykorzystywane jedynie dla celów administrowania serwerem.'
               }
            ]
         },
         {
            title: 'UDOSTĘPNIENIE I POWIERZENIE PRZETWARZANIA DANYCH.',
            items: [{
                  title: 'Dane podlegają udostępnieniu podmiotom zewnętrznym wyłącznie w granicach prawnie dozwolonych.'
               },
               {
                  title: 'Dane umożliwiające identyfikację osoby fizycznej są udostępniane wyłączenie za zgodą tej osoby.'
               },
               {
                  title: 'Operator może mieć obowiązek udzielania informacji zebranych przez Serwis upoważnionym organom na podstawie zgodnych z prawem żądań w zakresie wynikającym z żądania.'
               },
               {
                  title: 'W zakresie powierzenia przetwarzania danych osobowych Operator Serwisu zawarł pisemną umowę powierzenia przetwarzania danych, uregulowaną w art. 31 ustawy o ochronie danych osobowych, z dostawcą usług hostingowych OVH Sp. z o.o.'
               }
            ]
         },
         {
            title: 'ZARZĄDZANIE PLIKAMI COOKIES – JAK W PRAKTYCE WYRAŻAĆ I COFAĆ ZGODĘ?',
            items: [{
               title: 'Jeśli użytkownik nie chce otrzymywać plików cookies, może zmienić ustawienia przeglądarki. Zastrzegamy, że wyłączenie obsługi plików cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa, utrzymania preferencji użytkownika może utrudnić, a w skrajnych przypadkach może uniemożliwić korzystanie ze stron www'
            }]
         }
      ]
   },
   explorer: {
      error: {
         apiError: "Error on fetching data from server. Please try again later.",
         filterError: "Incorrect date range in th esearch form. Ensure that start date is before end date."
      },
      alerts: {
         title: "Alerts",
         emptyTitle: "There is no alerts for given date range",
         alert: {
               confirmationAlertTitle: "Confirmation Alert",
               detectionAlertTitle: "Detection Alert",
               locationCaption: "LOCATION",
               speciesCaption: "SPECIES",
               confidenceCaption: "CONFIDENCE"
         }
      },
      images: {
         title: "Sattelitte images",
         emptyTitle: "There is not sattellite images for given date range"
      },
      valuePicker: {
         disabledPlaceholder: "In order to use this tool, firstly select sattellite image from search panel"
      }
   }
}


// WEBPACK FOOTER //
// ./src/i18n/en.js